import { TAxiosResponse } from "types";
import { axiosInstance } from "./axiosInstance";
import { API_URL } from "@redux/rootConstant";
import {
  TGetStoreMasterDetailRes,
  TGetStoresMasterReq,
  TGetStoresMasterRes,
  TRegisStoreMasterReq,
  TUpdateStoreMasterReq,
} from "types/types";
import { DEFAULT_PAGE_SIZE } from "@constants";

const storeApi = {
  searchStores: async (payload: TGetStoresMasterReq) => {
    const page = payload.page ? payload.page : 1;
    const response: TAxiosResponse<TGetStoresMasterRes[]> =
      await axiosInstance.get(API_URL.STORE_MASTER.SEARCH, {
        params: {
          companyId: payload.companyId,
          sectorId: payload.sectorId,
          storeId: payload.storeId,
          page: page,
          pageSize: payload.pageSize || DEFAULT_PAGE_SIZE,
        },
      });

    return response;
  },

  createStore: async (payload: TRegisStoreMasterReq) => {
    const response: TAxiosResponse = await axiosInstance.post(
      API_URL.STORE_MASTER.COMMON,
      payload
    );
    return response;
  },

  updateStore: async (payload: TUpdateStoreMasterReq) => {
    const response: TAxiosResponse = await axiosInstance.put(
      `${API_URL.STORE_MASTER.COMMON}/${payload.id}`,
      payload
    );
    return response;
  },

  getDetailStore: async (payload: string) => {
    const response: TAxiosResponse<TGetStoreMasterDetailRes> =
      await axiosInstance.get(`${API_URL.STORE_MASTER.COMMON}/${payload}`);
    return response;
  },

  deleteStore: async (payload: string) => {
    const response: TAxiosResponse = await axiosInstance.delete(
      `${API_URL.STORE_MASTER.COMMON}/${payload}`
    );
    return response;
  },
};

export { storeApi };
